import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PageLayout } from "src/components/shopify/PageLayout";
import { Badge, Box, Button, IndexTable, Layout, Pagination } from "@shopify/polaris";
import { PolarisCard } from "src/components/shopify/PolarisCard";
import { PolarisEmptyState } from "src/components/shopify/PolarisEmptyState";
import {
  useMerchantDiscountItemCampaignQuery,
  useMerchantInactiveDiscountCampaignMutation,
} from "src/graphql/codegen_graphql";

export function DiscountListScreen() {
  const { t } = useTranslation();
  const [offset, setOffset] = useState(0);
  const [limit] = useState(25);

  const { data, loading } = useMerchantDiscountItemCampaignQuery({
    fetchPolicy: "no-cache",
    variables: {
      offset: offset * limit,
      limit: limit,
    },
  });
  const [merchantInactiveDiscountCampaign] = useMerchantInactiveDiscountCampaignMutation({
    refetchQueries: ["merchantDiscountItemCampaign"],
  });

  return (
    <PageLayout
      pageProp={{
        title: t("schedule_discount"),
        primaryAction: { url: "/discount/create", content: t("create_discount_item_campaign") },
      }}
    >
      <Layout>
        <Layout.Section>
          <PolarisCard padding={"0"} roundedAbove="sm">
            <Box>
              <Pagination
                type="table"
                label={<span>{`${offset * limit || 1}-${offset * limit + limit} of Schedule discount`}</span>}
                hasNext={data && data.merchantDiscountItemCampaign?.length === limit}
                hasPrevious={offset > 0}
                onNext={() => setOffset(offset + 1)}
                onPrevious={() => setOffset(offset - 1)}
              />
            </Box>
            <Box>
              <IndexTable
                headings={[
                  { title: t("active"), alignment: "center" },
                  { title: t("start_date") },
                  { title: t("end_date") },
                  { title: "" },
                  { title: t("control"), alignment: "end" },
                ]}
                itemCount={data ? data?.merchantDiscountItemCampaign?.length || 0 : 0}
                loading={loading}
                selectable={false}
                emptyState={<PolarisEmptyState />}
              >
                {data &&
                  data?.merchantDiscountItemCampaign?.map((x: any, i: number) => {
                    return (
                      <React.Fragment key={i}>
                        <IndexTable.Row id={i + ""} position={i}>
                          <IndexTable.Cell className="text-center">
                            <Badge size="small" tone={x.actived ? "success" : "critical"}>
                              {x.actived ? "Yes" : "No"}
                            </Badge>
                          </IndexTable.Cell>
                          <IndexTable.Cell>{x.start_date}</IndexTable.Cell>
                          <IndexTable.Cell>{x.end_date}</IndexTable.Cell>
                          <IndexTable.Cell></IndexTable.Cell>
                          <IndexTable.Cell>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                              <Button size="slim" url={`/discount/detail/${x.id}`}>
                                {t("detail")}
                              </Button>
                              <div className="ml-2 mr-2">
                                <Button size="slim" variant="primary" url={`/discount/edit/${x.id}`}>
                                  {t("edit")}
                                </Button>
                              </div>
                              {!!x.actived && (
                                <Button
                                  size="slim"
                                  variant="primary"
                                  tone="critical"
                                  onClick={() => {
                                    merchantInactiveDiscountCampaign({
                                      variables: {
                                        campaignId: Number(x.id),
                                      },
                                    });
                                  }}
                                >
                                  {t("remove")}
                                </Button>
                              )}
                            </div>
                          </IndexTable.Cell>
                        </IndexTable.Row>
                      </React.Fragment>
                    );
                  })}
              </IndexTable>
            </Box>
          </PolarisCard>
        </Layout.Section>
      </Layout>
    </PageLayout>
  );
}
